import { Dialog, DialogContent, DialogContentText, DialogTitle } from '@freighthub/silhouette-core'
import { inject, observer } from 'mobx-react'
import { Component, createElement } from 'react'
import { FAQService } from 'service/FAQService'
import { i18n, I18nInterface } from 'utils/localisation'

// open docx in libre office, copy all text and paste it here https://word2cleanhtml.com

interface ITermsAndConditionsProps extends I18nInterface {
  faqService?: FAQService
}

@inject('faqService')
@i18n
@observer
export class TermsAndConditionsDialog extends Component<ITermsAndConditionsProps> {
  render() {
    const {
      faqService,
      // @ts-expect-error TS(2339) FIXME: Property 'translate' does not exist on type 'Local... Remove this comment to see the full error message
      localisationStore: { translate },
    } = this.props
    return (
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      <Dialog open={faqService.isTermsOpen} onClose={faqService.closeTerms} maxWidth="sm">
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        <DialogTitle showClose onClose={faqService.closeTerms}>
          General Terms & Conditions
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {createElement('div', {
              dangerouslySetInnerHTML: {
                __html: translate('terms_and_conditions-text'),
              },
            })}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    )
  }
}
